export default [
  {
    title: "Article",
    customIcon: "ArticleSVG",
    children: [
      {
        title: "Article List",
        route: "custom-module",
        path: "/custom-module/article",
      },
      {
        title: "Article Category",
        route: "custom-module",
        path: "/custom-module/articleCate",
      },
    ],
  },
];
